// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1,
h2,
h3,
h4,
span {
  margin: 0;
  padding: 0;
}

ion-col {
  padding: 0;
}

.wrapper {
  text-align: center;
  padding: 26px 28px 36px;
  color: var(--color-black);
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.cross-line {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.cross-line ion-icon {
  --icon-color: #00000036;
  pointer-events: none;
  height: 16px;
  width: 16px;
}
.cross-line ion-icon.done {
  pointer-events: auto;
  --icon-color: var(--ion-color-primary);
}

.circle-wrapper {
  position: relative;
  margin: 0 auto 20px;
}

svg {
  transform: rotate(-90deg);
  animation: rotateInfinite 3s linear infinite;
}

@keyframes rotateInfinite {
  from {
    transform: rotate(-90deg);
  }
  to {
    transform: rotate(-450deg);
  }
}
circle {
  fill: none;
}

.bg {
  stroke: #e1e1e1;
}

.progress {
  stroke: var(--ion-color-primary);
  stroke-linecap: round;
}

.time {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 48px;
  font-weight: 600;
}

.time {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 48px;
  font-weight: 600;
  color: #000;
}

.title {
  font-family: AppFontTitle;
  font-size: 34px;
  line-height: 100%;
  letter-spacing: 0;
  text-align: center;
  color: var(--color-black);
  margin-bottom: 20px;
}

.text {
  font-family: AppFont;
  font-size: 17px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  color: var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/await-notification-modal/await-notification-modal.component.scss"],"names":[],"mappings":"AAAA;;;;;;EAMC,SAAA;EACA,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAIA;EACC,kBAAA;EACA,uBAAA;EACA,yBAAA;AADD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,aAAA;EACA,yBAAA;EACA,WAAA;AAAD;AAEC;EACC,uBAAA;EACA,oBAAA;EACA,YAAA;EACA,WAAA;AAAF;AAEE;EACC,oBAAA;EACA,sCAAA;AAAH;;AAKA;EACC,kBAAA;EACA,mBAAA;AAFD;;AAKA;EACC,yBAAA;EAEA,4CAAA;AAHD;;AAMA;EACC;IACC,yBAAA;EAHA;EAKD;IACC,0BAAA;EAHA;AACF;AAMA;EACC,UAAA;AAJD;;AAOA;EACC,eAAA;AAJD;;AAOA;EACC,gCAAA;EACA,qBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AAJD;;AAOA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAJD;;AAOA;EACC,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,mBAAA;AALD;;AAQA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AALD","sourcesContent":["p,\nh1,\nh2,\nh3,\nh4,\nspan {\n\tmargin: 0;\n\tpadding: 0;\n}\n\nion-col {\n\tpadding: 0;\n}\n\n$inline-padding: 28px;\n\n.wrapper {\n\ttext-align: center;\n\tpadding: 26px $inline-padding 36px;\n\tcolor: var(--color-black);\n}\n.content-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.cross-line {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\twidth: 100%;\n\n\tion-icon {\n\t\t--icon-color: #00000036;\n\t\tpointer-events: none;\n\t\theight: 16px;\n\t\twidth: 16px;\n\n\t\t&.done {\n\t\t\tpointer-events: auto;\n\t\t\t--icon-color: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n.circle-wrapper {\n\tposition: relative;\n\tmargin: 0 auto 20px;\n}\n\nsvg {\n\ttransform: rotate(-90deg);\n\n\tanimation: rotateInfinite 3s linear infinite;\n}\n\n@keyframes rotateInfinite {\n\tfrom {\n\t\ttransform: rotate(-90deg);\n\t}\n\tto {\n\t\ttransform: rotate(-450deg);\n\t}\n}\n\ncircle {\n\tfill: none;\n}\n\n.bg {\n\tstroke: #e1e1e1;\n}\n\n.progress {\n\tstroke: var(--ion-color-primary);\n\tstroke-linecap: round;\n}\n\n.time {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tfont-size: 48px;\n\tfont-weight: 600;\n}\n\n.time {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\tfont-size: 48px;\n\tfont-weight: 600;\n\tcolor: #000;\n}\n\n.title {\n\tfont-family: AppFontTitle;\n\tfont-size: 34px;\n\tline-height: 100%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\tcolor: var(--color-black);\n\n\tmargin-bottom: 20px;\n}\n\n.text {\n\tfont-family: AppFont;\n\tfont-size: 17px;\n\tline-height: 135%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\tcolor: var(--color-black);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
